import { TextInput, PasswordInput } from "../components/Inputs";
import { useState } from "react";
import useAxios from "../hooks/useAxios";
import { config } from "../config";
import { useParams } from "react-router-dom";
import { Button } from "../components/Button";
import StatesSelect from "../components/StatesSelect";

export default function Representatives({ profile, setStep, setProfile }:
    { profile: any, setStep: any, setProfile: any }) {
    const { id } = useParams<{ id: string }>();
    const axios = useAxios()
    const [errorMessage, setErrorMessage] = useState('')
    const [saving, setSaving] = useState(false);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        title: '',
        dob: '',
        ssn: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        country: 'USA',
        zipcode: '',
        ...(profile?.representatives?.[0] ?? {})
    })

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    };

    const handleNext = async () => {
        try {
            setSaving(true);
            setErrorMessage('')
            const newProfile = {...profile, representatives: [formData]}
            await axios.post(`${config.backendUrl}/accounts/onboarding-forms/${id}/`, newProfile)
            setProfile(newProfile)
            setStep((prev: number) => prev + 1)
        } catch (err: any) {
            console.error(err)
            setErrorMessage(err.response?.data?.message || 'An error occurred while saving the profile')
        } finally {
            setSaving(false);
        }
    }

    return (
        <div>
            <div className="mb-4">
                <TextInput label="Legal First Name" name="firstName" value={formData.firstName} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <TextInput label="Legal Last Name" name="lastName" value={formData.lastName} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <TextInput label="Title" name="title" value={formData.title} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <TextInput label="Email" name="email" value={formData.email} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <TextInput label="Phone Number" name="phone" value={formData.phone} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <TextInput label={"Date Of Birth (YYYY-MM-DD)"} name="dob" value={formData.dob} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <PasswordInput label="Social Security Number" name="ssn" value={formData.ssn} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <TextInput label="Address Line 1" name="addressLine1" value={formData.addressLine1} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <TextInput label="Address Line 2" name="addressLine2" value={formData.addressLine2} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <TextInput label="City" name="city" value={formData.city} onChange={handleInputChange} />
            </div>
            <StatesSelect handleInputChange={handleInputChange} formData={formData} />
            <div className="mb-4">
                <TextInput disabled label="Country" name="country" value={formData.country} onChange={handleInputChange} />
            </div>
            <div className="mb-4">
                <TextInput label="Zip Code" name="zipcode" value={formData.zipcode} onChange={handleInputChange} />
            </div>
            <p className="text-sm text-red-500 mb-3">{errorMessage}</p>
            <div className="space-x-3">
                <Button onClick={() => setStep((prev: number) => prev - 1)}>Previous</Button>
                <Button onClick={handleNext} disabled={saving}>{saving ? 'Saving...' : 'Continue'}</Button>
            </div>
        </div>
    )
}

